module.exports = __webpack_public_path__ + "static/css-page-8-2-780bfe2f1138b3fca3bd7bd4a38f0c8e.jpg";